import { login, logout, getInfo, fromOldFramework, permissions } from '@/api/login';

const app = {
    state: {
        token: '',
        schoolInfo: {},
        userInfo: {},
        departInfo: {},
        schoolTimeId: null,
        fromExternal: false,
        userDetail: {},
        permissions: [],
        permissionNameMapping: {},
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload.token;
        },
        SET_SCHOOLINFO(state, schoolInfo) {
            state.schoolInfo = schoolInfo;
        },
        SET_USERINFO(state, userInfo) {
            state.userInfo = userInfo;
        },
        SET_DEPARTINFO(state, departInfo) {
            state.departInfo = departInfo;
        },
        SET_PERMISSIONS: (state, permissionList) => {
            const permissions = [], permissionNameMapping = {};
            permissionList.forEach(item => {
                permissions.push(item.url.trim());
                permissionNameMapping[item.url.trim()] = item.name.trim();
            });
            state.permissions = permissions;
            state.permissionNameMapping = permissionNameMapping;
        },
        SET_SCHOOLTIMEID(state, schoolTimeId) {
            state.schoolTimeId = schoolTimeId;
        },
        SET_FROMEXTERNAL(state, fromExternal) {
            state.fromExternal = fromExternal;
        },
        SET_USERDETAIL(state, userDetail) {
            state.userDetail = userDetail;
        },

    },
    actions: {
        SET_TOKEN({commit}, payload) {
            commit('SET_TOKEN', payload);
        },
        SET_LOGININFO({commit}, payload) {
            commit('SET_DEPARTINFO', payload.departInfo);
            commit('SET_SCHOOLINFO', payload.schoolInfo);
            commit('SET_USERINFO', payload.userInfo);
        },
        SET_SCHOOLTIMEID({commit}, payload) {
            commit('SET_SCHOOLTIMEID', payload.schoolTimeId);
        },
        SET_FROMEXTERNAL({commit}, payload) {
            commit('SET_FROMEXTERNAL', payload.fromExternal);
        },
        SET_USERDETAIL({commit}, payload) {
            commit('SET_USERDETAIL', payload.userDetail);
        },
        FromOldFramework({ commit, state, dispatch }, userToken) {
            return new Promise((resolve, reject) => {
                fromOldFramework(userToken).then(response => {
                    const data = response.data.data;
                    Cookies.set('Admin-Token', data.token);
                    dispatch('SetInfo', data);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve(response);
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GetPermission({ commit, state, dispatch }) {
            return new Promise((resolve, reject) => {
                permissions().then(response => response.data)
                    .then(data => {
                        commit('SET_PERMISSIONS', data.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        SetInfo({commit, state}, data) {
            commit('SET_TOKEN', Cookies.get('Admin-Token'));
            commit('SET_USERINFO', data.userPageModel);
            commit('SET_SCHOOLINFO', data.schoolPageModel);
            commit('SET_ROLES', data.roleList);
            commit('SET_DEPARTS', data.departList);
        },
    }
};
export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js